import { FC } from "react";

import { Trans } from "react-i18next";

import Image, { ICONS } from "components/BaseComponents/Image";
import Typography from "components/BaseComponents/Typography";

import { DIGIPOSTHEME } from "theme/digiPosTheme";

import { StyledInnerContainer } from "./InfoCallCenter.styles";

const InfoCallCenter: FC = () => {
  return (
    <StyledInnerContainer className='theme-layout-background' margin='15px 0'>
      <Image
        alt='Button Logo'
        height='55px'
        margin='0px 0px 20px 10px'
        srcSet={ICONS.CALL_CENTER}
        width='40px'
      />

      <Typography
        align='center'
        color={DIGIPOSTHEME.colors.secondaryAkbankBlack}
        letterSpacing='0.23px'
        size='16px'
        transform='none'
        variant='span'
        weight='500'
      >
        <Trans i18nKey='info_call_center_title' />
      </Typography>
    </StyledInnerContainer>
  );
};

export default InfoCallCenter;
